(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-a-main-collection"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-main-collection"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-nutrients"] && !Shopify.designMode) return;
  try {
    
(function () {
  var LOREM = "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.";

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function initPeriodic(root) {
    var table = root.querySelector('.periodic__table');
    if (!table) return;

    var tiles = Array.prototype.slice.call(table.querySelectorAll('.pt-tile'));
    var art = root.querySelector('.periodic__art');
    var artImg = root.querySelector('.periodic__art-img');
    var elAbbr = root.querySelector('.pt-detail__abbr');
    var elName = root.querySelector('.pt-detail__name');
    var elPills = root.querySelector('.pt-detail__pills');
    var elHelp = root.querySelector('.pt-detail__help-text');
    var foundRow = root.querySelector('.pt-detail__found');

    // Build product lookup (key -> { name, color }) from the product tiles
    var products = {};
    tiles.forEach(function (t) {
      if (!t.classList.contains('pt-tile--product')) return;
      var key = (t.dataset.abbr || '').trim();
      if (!key) return;
      var nameEl = t.querySelector('.pt-name');
      products[key] = {
        name: nameEl ? nameEl.textContent.trim() : key.toUpperCase(),
        color: t.dataset.color || getComputedStyle(t).backgroundColor
      };
    });

    function showImage(src, alt) {
      if (!art || !artImg) return;
      if (!src) {
        art.classList.remove('is-shown');
        return;
      }
      artImg.onload = function () { art.classList.add('is-shown'); };
      artImg.onerror = function () { art.classList.remove('is-shown'); };
      artImg.alt = alt || '';
      artImg.src = src;
    }

    function select(tile) {
      if (tile.classList.contains('is-dim')) return;

      tiles.forEach(function (t) { t.classList.remove('is-active'); });
      tile.classList.add('is-active');

      var isProduct = tile.classList.contains('pt-tile--product');
      var abbrEl = tile.querySelector('.pt-abbr');
      var nameEl = tile.querySelector('.pt-name');
      var name = nameEl ? nameEl.textContent.trim() : '';

      if (elAbbr) elAbbr.textContent = abbrEl ? abbrEl.textContent.trim() : '';
      if (elName) elName.textContent = name;
      if (elHelp) elHelp.textContent = (tile.dataset.help && tile.dataset.help.trim()) || LOREM;

      // "Found in": nutrients list their products; product tiles show nothing
      var keys = isProduct ? [] : (tile.dataset.products || '')
        .split(',')
        .map(function (s) { return s.trim().toLowerCase(); })
        .filter(Boolean);

      var pillsHtml = keys.map(function (k) {
        var p = products[k];
        return p ? '<span class="pt-pill" style="background:' + p.color + '">' + escapeHtml(p.name) + '</span>' : '';
      }).join('');

      if (elPills) elPills.innerHTML = pillsHtml;
      if (foundRow) foundRow.style.display = pillsHtml ? '' : 'none';

      showImage(tile.dataset.image || '', name);
    }

    tiles.forEach(function (tile) {
      tile.addEventListener('mouseenter', function () { select(tile); });
      tile.addEventListener('click', function () { select(tile); });
    });

    var tabs = Array.prototype.slice.call(root.querySelectorAll('.periodic__tab'));
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('is-active'); });
        tab.classList.add('is-active');
        var cat = tab.dataset.cat;
        tiles.forEach(function (tile) {
          if (tile.classList.contains('pt-tile--product')) return;
          var dim = cat !== 'all' && tile.dataset.category !== cat;
          tile.classList.toggle('is-dim', dim);
        });
      });
    });

    // ---- scrollable category tabs (arrows on overflow + native swipe) ----
    (function () {
      var bar = root.querySelector('.periodic__tabsbar');
      var strip = root.querySelector('.periodic__tabs');
      var prevBtn = root.querySelector('.periodic__tabnav--prev');
      var nextBtn = root.querySelector('.periodic__tabnav--next');
      if (!bar || !strip) return;

      function update() {
        var overflow = strip.scrollWidth - strip.clientWidth;
        bar.classList.toggle('is-scrollable', overflow > 1);
        if (prevBtn) prevBtn.classList.toggle('is-disabled', strip.scrollLeft <= 1);
        if (nextBtn) nextBtn.classList.toggle('is-disabled', strip.scrollLeft >= overflow - 1);
      }

      function nudge(dir) {
        var amount = Math.max(120, strip.clientWidth * 0.7);
        strip.scrollBy({ left: dir * amount, behavior: 'smooth' });
      }

      // keep a clicked tab fully in view (scrolls the strip only, never the page)
      function ensureVisible(btn) {
        var c = strip.getBoundingClientRect();
        var b = btn.getBoundingClientRect();
        if (b.left < c.left) strip.scrollBy({ left: b.left - c.left - 8, behavior: 'smooth' });
        else if (b.right > c.right) strip.scrollBy({ left: b.right - c.right + 8, behavior: 'smooth' });
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { nudge(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { nudge(1); });
      strip.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      strip.addEventListener('click', function (e) {
        var btn = e.target.closest ? e.target.closest('.periodic__tab') : null;
        if (btn) ensureVisible(btn);
      });

      // recheck after layout settles (arrows toggling width, web fonts loading)
      update();
      requestAnimationFrame(update);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(update);
    })();

    // Default selection: the configured abbreviation, else the first nutrient
    var want = (table.dataset.defaultAbbr || '').trim().toLowerCase();
    var def = null;
    if (want) {
      def = tiles.filter(function (t) {
        return !t.classList.contains('pt-tile--product') && (t.dataset.abbr || '').toLowerCase() === want;
      })[0];
    }
    if (!def) {
      def = tiles.filter(function (t) { return !t.classList.contains('pt-tile--product'); })[0];
    }
    if (def) select(def);
  }

  document.querySelectorAll('.periodic').forEach(initPeriodic);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-scroll-anim-1"] && !Shopify.designMode) return;
  try {
    
  /* ============================================================
     Pinned stage: the name parts to the corners while the centre card
     opens, then the stage slides sideways through the panels.

     The sideways slide is STEPPED: every panel gets a move phase and a
     hold phase (data-hold = % of that panel's scroll spent standing
     still). So a panel arrives, pauses, then the next one slides in.

     Each [data-ed] runs its own timeline; every panel gets --rv for its
     centre-line reveal and caption fade-up.
     ============================================================ */
  (function () {
    var PART_FROM = 0.04,
      PART_TO = 0.2,
      SLIDE_FROM = 0.24,
      SLIDE_TO = 0.97;
    var states = [];

    function clamp01(v) {
      return Math.max(0, Math.min(1, v));
    }
    function ease(t) {
      return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
    }

    function build(sec) {
      if (!sec || sec.__edInit) return;
      var track = sec.querySelector('[data-ed-track]');
      var intro = sec.querySelector('[data-ed-intro]');
      if (!track || !intro) return;
      sec.__edInit = true;

      var fill = sec.querySelector('[data-ed-fill]');
      var panels = [].slice.call(track.children);
      var nameA = intro.querySelector('.ed__name--a');
      var nameB = intro.querySelector('.ed__name--b');
      /* share of each panel's scroll spent standing still */
      var hold = clamp01((parseFloat(sec.getAttribute('data-hold')) || 0) / 100);
      if (hold > 0.8) hold = 0.8;
      var st = { sec: sec, queued: false };

      st.measure = function () {
        if (!nameA || !nameB || !sec.offsetParent) return;
        var cx = intro.clientWidth / 2,
          cy = intro.clientHeight / 2;
        var a = {
          x: nameA.offsetLeft + nameA.offsetWidth / 2,
          y: nameA.offsetTop + nameA.offsetHeight / 2
        };
        var b = {
          x: nameB.offsetLeft + nameB.offsetWidth / 2,
          y: nameB.offsetTop + nameB.offsetHeight / 2
        };
        intro.style.setProperty('--ax', (cx - a.x).toFixed(1) + 'px');
        intro.style.setProperty('--ay', (cy - nameA.offsetHeight / 2 - a.y).toFixed(1) + 'px');
        intro.style.setProperty('--bx', (cx - b.x).toFixed(1) + 'px');
        intro.style.setProperty('--by', (cy + nameB.offsetHeight / 2 - b.y).toFixed(1) + 'px');
      };

      /* linear scroll 0-1  ->  stepped slide 0-1 (move, then hold) */
      function stepped(slide, steps) {
        if (steps < 1) return 0;
        var seg = slide * steps;
        var i = Math.floor(seg);
        if (i >= steps) return 1;
        var f = seg - i;
        var moveSpan = 1 - hold;
        var local = moveSpan > 0 ? ease(clamp01(f / moveSpan)) : 1;
        return (i + local) / steps;
      }

      st.update = function () {
        st.queued = false;
        if (!sec.offsetParent) return;
        var total = sec.offsetHeight - window.innerHeight;
        var p = total > 0 ? clamp01(-sec.getBoundingClientRect().top / total) : 0;

        var part = ease(clamp01((p - PART_FROM) / (PART_TO - PART_FROM)));
        intro.style.setProperty('--nv', part.toFixed(3));
        intro.style.setProperty('--rv', part.toFixed(3));

        var slide = clamp01((p - SLIDE_FROM) / (SLIDE_TO - SLIDE_FROM));
        var dist = track.scrollWidth - window.innerWidth;
        var x = stepped(slide, panels.length - 1) * (dist > 0 ? dist : 0);
        track.style.transform = 'translate3d(' + -x.toFixed(1) + 'px,0,0)';

        var vw = window.innerWidth;
        panels.forEach(function (panel, i) {
          if (i === 0) return;
          var rv = clamp01((x - panel.offsetLeft + vw * 0.85) / (vw * 0.85));
          panel.style.setProperty('--rv', rv.toFixed(3));
          /* the words panel waits for its image, then plays its own entrance */
          if (panel.classList.contains('ed__panel--words')) {
            panel.classList.toggle('is-open', rv > 0.92);
          }
        });

        if (fill) fill.style.width = (p * 100).toFixed(2) + '%';
      };

      st.queue = function () {
        if (!st.queued) {
          st.queued = true;
          requestAnimationFrame(st.update);
        }
      };

      states.push(st);
      st.measure();
      st.update();
      /* images finish loading after first paint and change offsetLeft */
      setTimeout(function () {
        st.measure();
        st.update();
      }, 400);
    }

    function boot() {
      var list = document.querySelectorAll('[data-ed]');
      for (var i = 0; i < list.length; i++) build(list[i]);
      queueAll();
    }
    function queueAll() {
      states.forEach(function (st) {
        st.queue();
      });
    }
    function measureAll() {
      states.forEach(function (st) {
        st.measure();
      });
    }

    if (!window.__edBound) {
      window.__edBound = true;
      window.addEventListener('scroll', queueAll, { passive: true });
      window.addEventListener('resize', function () {
        measureAll();
        queueAll();
      });
      window.addEventListener('load', function () {
        measureAll();
        queueAll();
      });

      /* theme editor: re-init when a section is added, moved or edited */
      document.addEventListener('shopify:section:load', function (e) {
        var sec = e.target.querySelector ? e.target.querySelector('[data-ed]') : null;
        if (sec) build(sec);
        measureAll();
        queueAll();
      });
      document.addEventListener('shopify:section:unload', function () {
        states = states.filter(function (st) {
          return document.body.contains(st.sec);
        });
      });
      document.addEventListener('shopify:block:select', function () {
        measureAll();
        queueAll();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }

    window.__edRefresh = function () {
      measureAll();
      queueAll();
    };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
